/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ConversationNotesGroup } from './conversationNotesGroup';
import type { ProfileNoteResponse } from './profileNoteResponse';

export interface JobProfileNoteListResponse {
  notes?: ProfileNoteResponse[];
  conversation_notes?: ConversationNotesGroup[];
}
